import SwitchActiveAndDeactiveProducts from "./switchActiveAndDeactiveProducts/switchActiveAndDeactiveProducts";

export default function ActiveAndDeactiveProductsModal({ products, setNeedReload, setListToUpdate, listToUpdate }) {
    if (!Array.isArray(products)) {
        return <p>Nenhum produto encontrado para esta categoria.</p>;
    }

    if (products.length === 0) {
        return <p>Não há produtos para esta categoria.</p>;
    }

    return (
        <div>
            {products.map((product) => (
                <div 
                    key={product.id} 
                    style={{ display: "flex", width: 400, justifyContent: "space-between", marginBottom: "10px" }}
                >
                    <p>{product.name}</p>
                    <SwitchActiveAndDeactiveProducts 
                        product={product} 
                        setNeedReload={setNeedReload} 
                        setListToUpdate={setListToUpdate} 
                        listToUpdate={listToUpdate}
                    />
                </div>
            ))}
        </div>
    )
}
